export default __webpack_public_path__ + "static/media/gallery29.7daa3d83.webp";